<template>
    
    <section>
        <div class="loading-spinner" v-if="isLoading">
            <base-spinner></base-spinner>
        </div>
        <div class="tbl_wrap" v-else>            
            <table class="tbl">
                <colgroup>
                    <col style="*" />                    
                    <col style="width:30%" />
                    <col style="width:30%" />
                </colgroup>
                <thead>
                    <tr>                         
                        <th class="txt-left">나를 추천인으로 등록한 유저</th>
                        <th>등록일</th>
                        <th>최근로그인</th>                        
                    </tr>
                </thead>   
                <tbody>
                    <template v-if="recommenderLists.data.length ===0">
                        <tr><td colspan="3">내역이 없습니다.</td></tr>                    
                    </template>
                    <template v-else>
                        <tr v-for="(list, index) in recommenderLists.data" :key="index">                         
                            <td class="article_writer">
                                <user-name-tag
                                    :user="list.user"
                                    :displaymytalk="false"
                                    :displayProfileImage="false"
                                    />              
                            </td>                          
                            <td><display-time :time="list.created_at"/></td>                                               
                            <td></td>
                        </tr>                       
                    </template>
                
                </tbody>     
            </table>        
        </div>
    
    </section>    
   
</template>
<script>
import { myRecommenderList } from '@/components/mixins/pages/myRecommenderList.js'
export default {
    name:'',
    props:[
        
    ],
    data(){
        return{

        }
    },
    mixins:[
        myRecommenderList
    ],
    components:{

    },
    mounted() {
    },
    methods:{
    }
}
</script>


<style lang="scss" scoped>
@import '@/assets/scss/table';
.tbl_wrap{
    padding:0;
}

.listSum{
    background:#000;
    td{
        color:#fff !important;
        strong{
            color:aqua;
        }
    }    
}
</style>